<h2 mat-dialog-title>{{ 'customerInvoices.messages.refundTitle' | translate }}</h2>

<mat-dialog-content *ngIf="step === 'selection'">
  <p class="refund-subtitle">{{ 'customerInvoices.messages.refundChooseType' | translate }}</p>
  <section class="refund-balance" aria-label="Saldo disponible para reembolso">
    <span>{{ 'customerInvoices.messages.refundAvailableBalance' | translate }}</span>
    <strong>{{ data.availableRefundAmount | number:'1.2-2' }}</strong>
  </section>

  <div class="refund-options" role="radiogroup">
    <div class="refund-option" role="radio" tabindex="0" [attr.aria-checked]="refundType === 'FULL'" [class.selected]="refundType === 'FULL'" (click)="selectRefundType('FULL')" (keydown.enter)="selectRefundType('FULL')" (keydown.space)="selectRefundType('FULL')">
      <strong>{{ 'customerInvoices.messages.refundFullRemaining' | translate }}</strong>
      <span>{{ 'customerInvoices.messages.refundFullDescription' | translate }}</span>
    </div>
    <div class="refund-option" role="radio" tabindex="0" [attr.aria-checked]="refundType === 'PARTIAL'" [class.selected]="isPartialRefundSelected" (click)="selectRefundType('PARTIAL')" (keydown.enter)="selectRefundType('PARTIAL')" (keydown.space)="selectRefundType('PARTIAL')">
      <strong>{{ 'customerInvoices.messages.refundPartial' | translate }}</strong>
      <span>{{ 'customerInvoices.messages.refundPartialDescription' | translate }}</span>
    </div>
  </div>

  <section class="partial-amount" *ngIf="isPartialRefundSelected">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'customerInvoices.messages.refundAmount' | translate }}</mat-label>
      <input matInput type="number" min="0.01" step="0.01" [formControl]="amount">
      <mat-hint>{{ 'customerInvoices.messages.refundAmountHint' | translate:{amount: (data.availableRefundAmount | number:'1.2-2')} }}</mat-hint>
      <mat-error *ngIf="amount.invalid">{{ 'customerInvoices.messages.refundAmountInvalid' | translate }}</mat-error>
    </mat-form-field>
  </section>

  <p class="selection-error" *ngIf="selectionRequired">{{ 'customerInvoices.messages.refundTypeRequired' | translate }}</p>
</mat-dialog-content>

<mat-dialog-content *ngIf="step === 'confirmation'">
  <p class="refund-subtitle">{{ 'customerInvoices.messages.refundConfirmationIntro' | translate:{amount: (refundAmount | number:'1.2-2')} }}</p>
  <section class="refund-summary">
    <div>
      <span>{{ 'customerInvoices.messages.refundAvailableBalance' | translate }}</span>
      <strong>{{ data.availableRefundAmount | number:'1.2-2' }}</strong>
    </div>
    <div>
      <span>{{ 'customerInvoices.messages.refundBalanceAfter' | translate }}</span>
      <strong>{{ remainingAmount | number:'1.2-2' }}</strong>
    </div>
  </section>
  <p class="refund-impact" *ngIf="refundType === 'FULL'">{{ 'customerInvoices.messages.refundFullWarning' | translate }}</p>
  <p class="refund-impact" *ngIf="refundType === 'PARTIAL'">{{ 'customerInvoices.messages.refundPartialWarning' | translate }}</p>
  <p class="refund-warning">{{ 'customerInvoices.messages.refundIrreversible' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions *ngIf="step === 'selection'">
  <button mat-button (click)="dialogRef.close()">{{ 'customerInvoices.messages.refundCancel' | translate }}</button>
  <button mat-raised-button color="primary" (click)="review()">{{ 'customerInvoices.messages.refundContinue' | translate }}</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="step === 'confirmation'">
  <button mat-button (click)="back()">{{ 'customerInvoices.messages.refundBack' | translate }}</button>
  <button mat-raised-button color="warn" (click)="confirm()">{{ 'customerInvoices.messages.refundConfirmAmount' | translate:{amount: (refundAmount | number:'1.2-2')} }}</button>
</mat-dialog-actions>
